<template>
  <div>
    <vs-sidebar
      click-not-close
      parent="#sample-view"
      :hidden-background="true"
      class="full-vs-sidebar sample-view-sidebar items-no-padding"
      v-model="isInnerSidebarActive"
      position-right
    >
      <div class="mail-sidebar-content px-0 sm:pb-6 h-full">
        <div
          class="flex flex-wrap items-center sample-header justify-between md:px-8 px-6 sm:pb-2 sm: pt-6 d-theme-dark-bg"
          v-if="selectedSample"
        >
          <div class="flex mb-4">
            <div class="flex items-center">
              <feather-icon
                icon="XIcon"
                @click="$emit('closeSidebar')"
                class="cursor-pointer mr-4"
                svg-classes="w-6 h-6"
              ></feather-icon>
              <h4>{{ this.selectedSample.sampleNumber }}</h4>
            </div>
          </div>
          <div class="ml-10 mb-4 mt-1">
            <div class="flex items-baseline">
              <vs-switch color="success" icon-pack="feather" vs-icon-on="icon-list" vs-icon-off="icon-bar-chart" v-model="isList">
                <span slot="on"></span>
                <span slot="off"></span>
              </vs-switch>
              <vx-tooltip v-if="!isImported && !isOrphan" :text="$t('Import')" position="bottom" delay=".3s">
                <feather-icon icon="CheckCircleIcon" class="cursor-pointer ml-5"  svg-classes="h-6 w-6" @click="openImportConfirm" />
              </vx-tooltip>
              <vx-tooltip v-if="isImported && !isOrphan" :text="$t('CancelImport')" position="bottom" delay=".3s">
                <feather-icon icon="XIcon" class="cursor-pointer ml-5" svg-classes="h-6 w-6" @click="openCancelImportConfirm" />
              </vx-tooltip>
              <feather-icon
                :icon="$vs.rtl ? 'ChevronsRightIcon' : 'ChevronsLeftIcon'"
                svg-classes="h-6 w-6"
                class="cursor-pointer ml-4 hidden sm:inline-flex"
                @click="$emit('previousSample')"
              />
              <feather-icon
                :icon="$vs.rtl ? 'ChevronsLeftIcon' : 'ChevronsRightIcon'"
                svg-classes="h-6 w-6"
                class="cursor-pointer ml-4 hidden sm:inline-flex"
                @click="$emit('nextSample')"
              />
            </div>
          </div>
        </div>

        <component
          :is="scrollbarTag"
          class="scroll-area-location-content md:px-8 md:pb-8 pt-4 px-6 pb-6"
          :settings="settings"
          :key="$vs.rtl"
          id="test"
        >
          <div v-show="isSidebarActive">
            <div class="vx-row mb-base">
              <div class="vx-col w-2/3">
                <vx-card :title="$t('GradeControl.Sample.SampleMeasures')" class="mb-base" v-show="isList">
                  <ag-grid-vue
                    ref="agGridTable"
                    :components="components"
                    :gridOptions="gridOptions"
                    :context="context"
                    class="ag-theme-material w-100 my-4 ag-grid-table"
                    :columnDefs="columnDefs"
                    :defaultColDef="defaultColDef"
                    :rowClassRules="rowClassRules"
                    :rowData="sampleMeasureList"
                    rowSelection="multiple"
                    colResizeDefault="shift"
                    :animateRows="true"
                    :pagination="false"
                    :suppressPaginationPanel="true"
                    :enableRtl="$vs.rtl">
                  </ag-grid-vue>
                </vx-card>               
                <vx-card :title="$t('GradeControl.Grade')"  class="mb-base" v-show="!isList">
                  <SamplesScatter ref="samplesScatter" @onUpdateSampleMeasure="updateSampleMeasure" :mesuredElement="selectedMeasuredElement" :isImported="isImported" />
                </vx-card>
              </div>
              <div class="vx-col w-1/3">
               <vx-card :title="$t('GradeControl.AverageGrades')" class="mb-base">
                 <AverageGrades
                  v-if="selectedSample"
                  :sampleNumber="selectedSample.sampleNumber"
                  :sampleMeasures="sampleMeasureList"
                  :locationStats="locationStats"
                  :selectedMeasuredElement="selectedMeasuredElement"
                  @onUpdateMeasureElement="updateMeasureElement"
                  :sampleResultInfos="sampleResultInfos" />
                </vx-card>
               <vx-card :title="$t('GradeControl.Location.Title') + '/' + $t('GradeControl.Sample.Title')" class="mb-base" v-show="!isList">
                  <GradeBoxPlot ref="gradeBoxPlot" :mesuredElement="selectedMeasuredElement"/>
                </vx-card>
              </div>
            </div>
          </div>
        </component>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import Vue from "vue"
import { AgGridVue } from "ag-grid-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import MeasuredElementEnum from '../../MeasuredElementEnum.js';
import SampleStatusEnum from '../../SampleStatusEnum';
import SampleMeasureActionsCellRenderer from './SampleMeasureActionsCellRenderer.vue'
import GradeBoxPlot from "./GradeBoxPlot.vue"
import SamplesScatter from "./SamplesScatter.vue"
import AverageGrades from "./AverageGrades.vue"


export default {
  name: 'SampleView',
  props: {
    openSample: {
      type: Object
    },
    isSidebarActive: {
      type: Boolean,
      required: true
    }
  },
  components: {
    AgGridVue,
    VuePerfectScrollbar,
    GradeBoxPlot,
    SamplesScatter,
    AverageGrades
  },
  data() {
    return {
      isList: false,
      selectedSample : null,
      showThread: false,
      isInnerSidebarActive: false,
      selectedMeasuredElement: MeasuredElementEnum.Gold,
      locationStats: null,
      isImported: false,
      isOrphan : false,
      sampleMeasureList: [],
      sampleResultInfos: [],
      measuredElements: [
        { id:MeasuredElementEnum.Gold, name:this.$t("MeasuredElement." + MeasuredElementEnum.Gold) },
        { id:MeasuredElementEnum.Silver, name:this.$t("MeasuredElement." + MeasuredElementEnum.Silver) },
        { id:MeasuredElementEnum.Copper, name:this.$t("MeasuredElement." + MeasuredElementEnum.Copper) },
        { id:MeasuredElementEnum.Zinc, name:this.$t("MeasuredElement." + MeasuredElementEnum.Zinc) },
        { id:MeasuredElementEnum.Lead, name:this.$t("MeasuredElement." + MeasuredElementEnum.Lead) }
      ],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.5
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        editable: false
      },
      rowClassRules: {
        'timesheet-approved': 'data.timesheetImportationId != null',
        'timesheet-modified': 'data.timesheetImportationId == null && data.modificationDate != null'
      },
      gridApi: null,
      gridOptions: {
        getRowNodeId: (data) => {
          return data.sampleMeasureId;
        }
      },
      context: { componentParent: this },
      columnDefs: [
        {
          headerName: 'Actions',
          field: 'sampleMeasureId',
          width: 105,
          editable: false,
          sortable: false,
          cellRendererFramework: Vue.extend(SampleMeasureActionsCellRenderer)
        },
        {     
          headerName: this.$t('GradeControl.Sample.QCType'),
          field: "qcType",
          width: 150,
          filter:'agNumberColumnFilter',
          filterParams: {
            valueGetter: params => {
              return this.$t("QCType." + params.data.qcType);
            }
          },
          valueGetter: params => {
            return this.$t("QCType." + params.data.qcType);
          }
        },
        { 
          headerName: this.$t('MeasuredElement.Title'),
          field: "sampleResultInfos",
          width: 150,
          filter:'agNumberColumnFilter',
          filterParams: {
            valueGetter: params => {
              return this.$t("MeasuredElement." + params.data.element);
            }
          },
          valueGetter: params => {
            return this.$t("MeasuredElement." + params.data.element);
          }
        },
        { 
          headerName: this.$systemUnits.getGradeLabel('Gold'),
          field: "value",
          valueGetter: params => {
            return this.$systemUnits.convertGradeRounded(params.data.value, params.data.element);
          },
          filter: true,
          width: 155,
          valueFormatter: this.formatGrade
        }
      ],
      components: {
        SampleMeasureActionsCellRenderer
      }
    };
  },
  watch: {
    isSidebarActive(value) {
      this.isInnerSidebarActive = value;
    },
    isInnerSidebarActive(value) {
      if (!value) {
        this.$emit("closeSidebar");
        setTimeout(() => {
          this.showThread = false;
        }, 500);
      } 
    },
    openSample(value) {
      if (value) {
         
        this.$vs.loading();
        this.$webApi.get("geo/gradecontrol/limssampleresult/GetBySampleCode/", {
          params: {
            projectId: value.projectId,
            sampleNumber: value.sampleNumber,
            certificationDate : value.certifiedDate
          }
        }).then((response) => {
          this.selectedSample = response.data;
          this.refreshSampleDatas(this.selectedSample);
        }).finally(() => this.$vs.loading.close());
      }  
    }
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    }
  },
  methods: {
    formatGrade(params) {
      return this.$options.filters.toFriendlyGrade(this.$systemUnits.convertGradeRounded(params.value, params.element));
    },
    getElementLocationStatsGrade(element) {
      if (this.locationStats && this.locationStats !== null) {
        const elementStats = this.locationStats.elementsGradeStats.find(e => e.element === element);

        if (typeof elementStats !== 'undefined') {
          return this.$systemUnits.convertGradeRounded(elementStats.grade, element);
        } 
      }

      return   "N/A";
      
    },
    updateMeasureElement(measureElement) {
      this.selectedMeasuredElement = measureElement;
    },
    updateSampleMeasure(sampleMeasureId) {
      if (sampleMeasureId) {
        const targetSample = this.selectedSample.sampleMeasures.find(s => s.sampleMeasureId === sampleMeasureId);
        targetSample.isExcluded = !targetSample.isExcluded;

        this.$vs.loading();
        // update sample, then refresh location Forecast so that it reflect excluded samples
        this.$store.dispatch("gradeControl/updateLimsSample", this.selectedSample).then((result) => {
          this.refreshSampleDatas(result.data);
          this.$emit("onUpdateSample", result.data);
        }).finally(() => this.$vs.loading.close());
      }
    },
    updateSample(sample) {
      if (sample) {
        const targetSample = this.selectedSample.sampleMeasures.find(s => s.sampleMeasureId === sample.sampleMeasureId);
        targetSample.isExcluded = sample.isExcluded;

        this.$vs.loading();
        // update sample, then refresh location Forecast so that it reflect excluded samples
        this.$store.dispatch("gradeControl/updateLimsSample", this.selectedSample).then((result) => {
          this.refreshSampleDatas(result.data);
          this.$emit("onUpdateSample", result.data);
        }).finally(() => this.$vs.loading.close());
      }
    },
    refreshSampleDatas(limsSampleResult) {
      this.sampleMeasureList = limsSampleResult === null ? [] : limsSampleResult.sampleMeasures;
      this.isImported =  limsSampleResult === null ? false : limsSampleResult.status === SampleStatusEnum.ImportedNoExclusion || limsSampleResult.status === SampleStatusEnum.ImportedWithExclusion;
      this.isOrphan = limsSampleResult === null ? false : limsSampleResult.status === SampleStatusEnum.Orphan;
      this.sampleResultInfos = limsSampleResult === null ? [] : limsSampleResult.sampleResultInfos;
      this.$cqrsGet("geo/gradecontrol/locations/FindLocationStats", {
        params: {
          projectId: limsSampleResult.projectId,
          sampleCode: limsSampleResult.sampleNumber
        }
      })
        .then((response) => {
          this.locationStats = response.data.model;
          this.$refs.samplesScatter.fillDatas(limsSampleResult, this.locationStats);
          this.$refs.gradeBoxPlot.fillDatas([this.locationStats], limsSampleResult.sampleResultInfos, this.selectedSample.sampleNumber);
          this.$refs.samplesScatter.bindChartData(this.selectedMeasuredElement);
        })
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: this.$t("LoadingError"),
            text: error.message
          });
        });

    },
    openImportConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: this.$t("Import"),
        text: this.$t('GradeControl.Sample.ConfirmSingleImport'),
        accept: this.import
      });
    },

    import() {
      this.$vs.loading();
      this.$webApi.post('geo/gradecontrol/SampleImportation/', {
        sampleNumbers: [this.selectedSample.sampleNumber],
        projectId: this.selectedSample.projectId,
        certificationDate : this.selectedSample.certifiedDate
      }).then((result) => {

        if (result.data.isSuccess) {
          this.$vs.notify({
            title: this.$t("Import"),
            text: this.$t("GradeControl.Sample.ImportCompleted"),
            color: "success",
            iconPack: 'feather',
            icon:'icon-check'
          });
          
          this.$webApi.get("geo/gradecontrol/limssampleresult/GetBySampleCode/", {
            params: {
              projectId: this.selectedSample.projectId,
              sampleNumber: this.selectedSample.sampleNumber,
              certificationDate : this.selectedSample.certifiedDate
            }
          }).then((response) => {
            this.refreshSampleDatas(response.data);
            this.$emit("onUpdateSample", response.data);
          })
        }
        else {
          this.importationPopupActive = true;
          this.importationResults = result.data.results;
        }
      
      }).finally(() => {
        this.$vs.loading.close();
      });
    },
    openCancelImportConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: this.$t("Import"),
        text: this.$t('GradeControl.Sample.ConfirmCancelImport'),
        accept: this.cancelImportation
      });
    },

    cancelImportation() {
      this.$vs.loading();
      this.$webApi.post('geo/gradecontrol/SampleImportation/CancelImportation/', {
        projectId: this.selectedSample.projectId,
        sampleNumbers: [this.selectedSample.sampleNumber],
        certificationDate : this.selectedSample.certifiedDate
      }).then(() => {

        this.$vs.notify({
          title: this.$t("Import"),
          text: this.$t("GradeControl.Sample.CancelImportCompleted"),
          color: "success",
          iconPack: 'feather',
          icon:'icon-check'
        });
  
        this.$webApi.get("geo/gradecontrol/limssampleresult/GetBySampleCode/", {
          params: {
            projectId: this.selectedSample.projectId,
            sampleNumber: this.selectedSample.sampleNumber,
            certificationDate : this.selectedSample.certifiedDate
          }
        }).then((response) => {
          this.refreshSampleDatas(response.data);
          this.$emit("onUpdateSample", response.data);
        })
      
      }).finally(() => {
        this.$vs.loading.close();
      });
    }
    
  }
};
</script>

<style lang="scss">
#test {
  .location-content-scroll-area {
      position: relative;
      margin: auto;
      width: 100%;
      height: calc(100% - 100px);

      &:not(.ps) {
        overflow-y: auto;
      }
  }

  .scroll-area-location-content {
    position: relative;
    margin: auto;
    width: 100%;
    height: calc(100% - 6.3%);

    &:not(.ps) {
      overflow-y: auto;
    }
  }
}
</style>